import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { CreateClientFormData } from '@/types/clientsApiTypes';
import { getDefaultFormData } from '../../utils/getDefaultFormData';
import { useGetClientDocuments } from '../useGetClientDocuments';
import { useGetClientDetailsQuery } from '../useGetClientQuery';
import { useGetRelatedPassengersQuery } from '../useGetRelatedPassengersQuery';
import { useMemo } from 'react';
import { useGetClientPassportData } from '../useGetClientPassportData';

interface UseGetDefaultFormDataResponse {
  defaultFormData: CreateClientFormData;
  isLoading: boolean;
}

export const useGetDefaultFormData = (): UseGetDefaultFormDataResponse => {
  const [query] = useSearchQuery();
  const clientId = query.get(CLIENT_ID_QUERY_KEY);
  const { data: clientData, isLoading: isClientLoading } = useGetClientDetailsQuery();
  const { data: documentsData, isLoading: isDocumentsLoading } = useGetClientDocuments(clientId);
  const { data: passportData, isLoading: isPassportLoading } = useGetClientPassportData(clientId);
  const { data: relatedPassengersData, isLoading: isRelatedPassengersLoading } = useGetRelatedPassengersQuery();

  const defaultFormData = useMemo(() => {
    return getDefaultFormData(clientData?.data, documentsData?.data, relatedPassengersData?.data, passportData?.data);
  }, [clientData?.data, documentsData?.data, relatedPassengersData?.data, passportData?.data]);

  const isLoading = isClientLoading || isDocumentsLoading || isRelatedPassengersLoading || isPassportLoading;

  return {
    defaultFormData,
    isLoading,
  };
};
